import { mount } from 'svelte'
import './app.css'
import './assets/styles/common.css';
import './assets/styles/swiper.min.css';
import './assets/styles/bootstrap-datetimepicker.min.css';

import App from './App.svelte'

const app = mount(App, {
  target: document.getElementById('app'),
})

export default app
